import { Box, Heading, IconButton } from "@chakra-ui/react"
import { useState, useEffect } from "react"
import { IoChevronBackOutline } from 'react-icons/io5'
import FadeIn from 'react-fade-in';
import { useNavigate } from 'react-router-dom'

const TopBarPercorso = () => {
    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', controlNavbar);

            // cleanup function
            return () => {
                window.removeEventListener('scroll', controlNavbar);
            };
        }
    }, [lastScrollY]);

    const controlNavbar = () => {
        if (typeof window !== 'undefined') {
            if (window.scrollY !== 0) {
                setShow(false);
            } else {
                setShow(true);
            }

            setLastScrollY(window.scrollY);
        }
    };

    const toHome = () => {
        navigate("/");
    }

    return (
        <Box w='100%' position='fixed' p={[2, 2, 2]} bgColor={!show ? "gray.300" : null} textColor='white'>
            <Box display='flex' alignItems='center' ml={[1, 4, 8]} mr={[2, 4, 8]} h='40px' >

                <IconButton
                    bg='gray.300'
                    textColor='white'
                    aria-label='Back'
                    icon={<IoChevronBackOutline />}
                    onClick={toHome}
                />
                {show ?
                    <Heading as='h3' size='lg' letterSpacing={1} ml={2}>Percorsi</Heading> :
                    <FadeIn>
                        <Heading as='h3' size='md' letterSpacing={1} ml={2}>Percorsi</Heading>
                    </FadeIn>
                }

            </Box>
        </Box>
    )
}

export default TopBarPercorso